import axios from '../../axios';
import {
  ADD_STATE,
  GET_STATES,
  GET_STATE,
  UPDATE_STATE,
  DELETE_STATE,
  UPDATE_COUNTRY,
} from '../types';
import { setAlert } from './alert';

// Add State
export const addState = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/state/add`, formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_STATE, payload: res.data.data });
      dispatch(setAlert(res.data.message, 'success'));
      return res.data;
    } else {
      dispatch(setAlert(res.data.message, 'warning'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};
export const updateStateStatus = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/state/status`, formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY, payload: res.data.data });
      dispatch(setAlert(res.data.message, 'success'));
    } else {
      dispatch(setAlert(res.data.message, 'warning'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Get getStates
export const getStates = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/state/all`, {params});
    if (res.data.code === 1) {
      dispatch({ type: GET_STATES, 
        payload: {
          data: res.data.data || [],
          pagination: res.data.pagination || {},
          totalCount: res.data.totalCount || 0,
        },
       });
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Get getStatesByCountry
export const getStatesByCountry = (country) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/state/country`,
      { coId: country },
    );
    if (res.data.code === 1) {
      let payload = Array.isArray(res?.data?.data) ? res?.data?.data : [];
      dispatch({ type: GET_STATES, payload: payload });
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Get Single State
export const getState = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_ADMIN_URL}/state/${id}`,
    );
    if (res.data.code === 1) {
      dispatch({ type: GET_STATE, payload: res.data.data });
      dispatch(setAlert(res.data.message, 'success'));
    } else {
      dispatch(setAlert(res.data.message, 'warning'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Clear Single State
export const clearSingleState = () => async (dispatch) => {
  try {
    dispatch({ type: GET_STATE, payload: '' });
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Update State
export const updateState = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/state/update`, formData);
    // `${process.env.REACT_APP_ADMIN_URL}/state/${id}`
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_STATE, payload: res.data.data });
      dispatch(setAlert(res.data.message, 'success'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Delete State
export const deleteState = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert('Please select any record', 'warning'));
      return false;
    }
    const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/state/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_STATE, payload: { id } });
      dispatch(setAlert(res.data.message, 'success'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};
